<div *ngIf="isShow" class="container">
  <img class="img-responsive" height="163px" src="{{bannerSetting?.settingValue}}">
</div>
<!-- <div class="d-flex justify-content-between">
  <div class="wb-logo">
    <img src="./assets/website/logo.png">
  </div>
  <div class="wb-button-login">
    <a class="btn btn-primary mt-5" href="/admin">Đăng Nhập</a>
  </div>
</div> -->
